import React from 'react';
import ClockBar from './ClockBar';
import logo from '../../assets/Logo_EssilorLuxottica_black.png';

const HeaderBar: React.FC = () => {
    return (
        <header className="d-flex justify-content-between align-items-center p-3 bg-light shadow-sm">
            <div className="logo-container">
                <img className="el-logo" src={logo} alt="Logo" />
                <h2 className="px-1" style={{ pointerEvents: 'none', color:'black'}}>The Hub</h2>
            </div>
            <div className="d-flex align-items-center">
                <ClockBar />
            </div>
        </header>
    );
};

export default HeaderBar;
